import './ServiceOrderItems.scss';

import type { FormProps } from 'antd';
import { Form } from 'antd';
import { type Dispatch, type SetStateAction, useMemo } from 'react';

import { ServiceOrderItem } from '@/model/ServiceOrder/ServiceOrderItem';

import ServiceOrderShippedItems from './ServiceOrderShippedItems/ServiceOrderShippedItems';
import ServiceOrderItemsStockSection from './ServiceOrderTechnicianStock/ServiceOrderTechnicianStock';
import useServiceOrderItemsForm from './useServiceOrderItemsForm';

interface ServiceOrderItemsProps {
  formProps?: FormProps;
  serviceOrderItems: ServiceOrderItem[];
  // Permite updates funcionales para evitar sobreescrituras.
  setServiceOrderItems: Dispatch<SetStateAction<ServiceOrderItem[]>>;
  editMode?: boolean;
  onInvalidDistributionChange?: (hasInvalid: boolean) => void;
}

const FormValue = () => null;
const ServiceOrderItems = (props: ServiceOrderItemsProps) => {
  const { formProps, serviceOrderItems, setServiceOrderItems, onInvalidDistributionChange } = props;
  const { shippedItems, isLoading, tickets } = useServiceOrderItemsForm(
    serviceOrderItems,
    setServiceOrderItems,
    formProps,
  );
  const serviceOrderItemsFromPackage = useMemo(
    () => serviceOrderItems.filter(so => so.package_item),
    [serviceOrderItems],
  );
  const serviceOrderItemsFromTechnician = useMemo(
    () => serviceOrderItems.filter(so => !so.package_item),
    [serviceOrderItems],
  );

  return (
    <div className="ServiceOrderItems">
      <ServiceOrderShippedItems
        serviceOrderItems={serviceOrderItemsFromPackage}
        setServiceOrderItems={setServiceOrderItems}
        shippedItems={shippedItems}
        isLoading={isLoading}
        tickets={tickets}
        onInvalidDistributionChange={onInvalidDistributionChange}
      />
      <ServiceOrderItemsStockSection
        serviceOrderItems={serviceOrderItemsFromTechnician}
        setServiceOrderItems={setServiceOrderItems}
      />
      <Form.Item name="service_order_items" hidden>
        <FormValue />
      </Form.Item>
    </div>
  );
};

export default ServiceOrderItems;
